declare const window: any;

const toastr = require('toastr')
const Backbone = require('backbone')
const jQuery = require('jquery')
const moment = require('moment')
const accounting = require('accounting')
const _ = require('underscore')
const $ = require('jquery')
import { DomainDataError } from 'app/api/types/DomainDataError';
import { DomainDataType } from 'app/api/types/DomainDataType';
import { RetornoApi } from 'app/api/types/RetornoApi';
import store from 'app/redux/store/store';
import { DataFormatoEN } from 'app/types/DataFormatoEN';
import { DataFormatoPT } from 'app/types/DataFormatoPT';
import { DataHoraFormatoENComT } from 'app/types/DataHoraFormatoENComT';
import { Permissao } from 'app/types/Permissao';
import * as R from 'ramda'
import * as dateFns from 'date-fns'
import { processamentoFinalizadoAction, processamentoIniciadoAction } from 'app/redux/aguardandoProcessamentoSlice';


type BlockUIOptions = {
    el?: any,
    tryPassiveLoading?: boolean,
    message?: string
}

type UnblockUIOptions = {
    el?: any
}

const globalMU = {

    dots: 0,
    applyingCalendars: false,
    _screenBlockKeyboardHandler: null as ((e: KeyboardEvent) => void) | null,
    blockMessageAnimation: null as ReturnType<typeof setInterval> | null,
/*
    showProcessingToast: function(messages: string | string[], title?: string, blockScreen: boolean = true): void {
        // Se já existe um aviso, primeiro o remova.  
        this.removeProcessingToast();
        const avisoId = 'fixed-processing-aviso'; 
        const baseMessage = Array.isArray(messages) ? messages.join("<br>") : messages;

        // Cria a estrutura HTML do aviso
        const avisoHtml = `
            <div id="${avisoId}" class="aviso-processing" style="opacity: 0.9">
                <div class="aviso-content"> 
                    ${title ? `<div class="aviso-title">${title}</div>` : ''} 
                    ${baseMessage ? `
                    <div class="aviso-message"> 
                        <span class="message-text">${baseMessage}</span>
                    </div>` : ''}
                </div>
                <div class="aviso-border-animation"></div>
            </div>
        `;
        
        $('body').append(avisoHtml);
        
        // Se blockScreen for true, bloqueia a tela toda com opacidade
        if (blockScreen) {
            this.blockUI({
                message: null,
                tryPassiveLoading: false,
                overlayCSS: {
                    opacity: 0.7,
                    backgroundColor: '#000'
                }
            });
        }
    },

    removeProcessingToast: function(): void {
        const $aviso = $('#fixed-processing-aviso');
        if ($aviso.length) {
            $aviso.fadeOut(300, () => $aviso.remove());
        }
        
            // Remove o bloqueio da tela se estiver ativo
            this.unblockUI();
    },
*/    

showProcessingToast: function(messages: string | string[], title?: string, blockScreen: boolean = false, opacity: number = 0.3): void {
    // Se já existe um aviso, primeiro o remova.  
    this.removeProcessingToast()

    const avisoId = 'fixed-processing-aviso';
    const baseMessage = Array.isArray(messages) 
                ? messages.join("<br>") 
                : messages

    // Se for para bloquear a tela, chama o método blockScreen só pelo backdrop/bloqueio de
    // interação — a mensagem/título já são exibidos pelo aviso próprio (avisoHtml, abaixo), que
    // sempre é montado independente de blockScreen. Passar `message` aqui também fazia o
    // blockScreen desenhar seu PRÓPRIO ".aviso-processing" com o mesmo texto (ver options.message
    // em blockScreen), duplicando a mensagem na tela sempre que messages não era vazio — passava
    // despercebido porque todo chamador existente usava messages="" (só título).
    if (blockScreen) {
        this.blockScreen({
            opacity: opacity,
            exibirIcone: !title && !baseMessage
        })
    }

    // Cria a estrutura HTML do aviso (versão original sem bloquear tela)
    const avisoHtml = `
        <div 
            id="${avisoId}" 
            class="aviso-processing" 
            style="opacity: 0.9; cursor: wait;"
        >
            <div class="aviso-content"> 
                ${title ? `<div class="aviso-title">${title}</div>` : ''} 
                ${baseMessage ? `
                <div class="aviso-message"> 
                    <span class="message-text">${baseMessage}</span>
                </div>` : ''}
            </div>
            <div class="aviso-border-animation"></div>
        </div>
    `;
    $('body').append(avisoHtml);
},

removeProcessingToast: function(): void {
    // Remove tanto o aviso normal quanto o bloqueio de tela
    const $aviso = $('#fixed-processing-aviso');
    if ($aviso.length) {
        $aviso.fadeOut(300, () => $aviso.remove());
    }
    
    // Remove também o bloqueio de tela se existir
    this.unblockScreen();
},

blockScreen: function(options: { opacity?: number, message?: string, exibirIcone?: boolean } = {}) {
    const opacity = options.opacity || 0.01;
    // options.message nunca era renderizado aqui (bug): a assinatura promete a mensagem mas só o
    // ícone de "processando" era desenhado. Por padrão some com o ícone quando há mensagem (mesmo
    // critério do showProcessingToast), a não ser que o chamador force exibirIcone explicitamente.
    const exibirIcone = options.exibirIcone === true || (options.exibirIcone === undefined && !options.message);

    // Remove qualquer bloqueio anterior existente
    this.unblockScreen();

    // Cria a overlay de bloqueio
    const overlayHtml = `
        <div id="screen-block-overlay" tabindex="0" style="
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, ${opacity});
            z-index: 99998;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: wait;
            outline: none;
        ">
            ${exibirIcone ? `
            <div class="screen-block-overlay__icone-processando">
                <div class="screen-block-overlay__icone-processando-gradiente"></div>
            </div>` : ''}
            ${options.message ? `
            <div class="aviso-processing" style="opacity: 0.9; cursor: wait;">
                <div class="aviso-content">
                    <div class="aviso-message"><span class="message-text">${options.message}</span></div>
                </div>
                <div class="aviso-border-animation"></div>
            </div>` : ''}
        </div>
    `;

    $('body').append(overlayHtml);

    // Bloqueia teclado (Tab, Enter, digitação) capturando na fase capture
    // para impedir que eventos cheguem a elementos por trás da overlay
    this._screenBlockKeyboardHandler = (e: KeyboardEvent) => {
        e.preventDefault();
        e.stopPropagation();
    };
    document.addEventListener('keydown', this._screenBlockKeyboardHandler, true);
    document.addEventListener('keypress', this._screenBlockKeyboardHandler, true);

    // Foca a overlay para que Tab não mova o foco para elementos de fundo
    const overlay = document.getElementById('screen-block-overlay');
    if (overlay) overlay.focus();

    // Bloqueia a interação com a página
    $('body').css('overflow', 'hidden');
},

unblockScreen: function() {
    // Remove a overlay de bloqueio
    $('#screen-block-overlay').remove();

    // Remove os listeners de teclado
    if (this._screenBlockKeyboardHandler) {
        document.removeEventListener('keydown', this._screenBlockKeyboardHandler, true);
        document.removeEventListener('keypress', this._screenBlockKeyboardHandler, true);
        this._screenBlockKeyboardHandler = null;
    }

    // Restaura o scroll da página
    $('body').css('overflow', '');
},
    vazioOuNulo: function(valor) {
        return R.isEmpty(valor) || R.isNil(valor)
    },

    preenchido: function(valor) {
        return !globalMU.vazioOuNulo(valor)
    },

    formatarValorNumerico: function (valor, numeroCasasDecimais = 2, exibirSimboloMonetario = false) {
        if (valor == null || isNaN(valor)) {
            valor = 0;
        }
        if (isNaN(numeroCasasDecimais)) {
            numeroCasasDecimais = 2
        }

        const options: Intl.NumberFormatOptions = {
            minimumFractionDigits: numeroCasasDecimais,
            maximumFractionDigits: numeroCasasDecimais,
            style: exibirSimboloMonetario ? "currency" : "decimal"
        };

        if (exibirSimboloMonetario) {
            (options as any).currency = "BRL";
        }

        return new Intl.NumberFormat('pt-BR', options).format(valor);
    },

    teclaDigitadaEhValidaParaCampoNumerico: function (teclaDigitada:string, valorOndeSeraAplicado: string = null) {
        const teclaDigitadaEhValida = R.includes(teclaDigitada,["1","2","3","4","5","6","7","8","9","0",","])
        const jaExisteVirgulaNoValor = valorOndeSeraAplicado?.indexOf?.(",") != -1
        const teclaDigitadaEhVirgula = teclaDigitada == ","

        return teclaDigitadaEhValida && ( !teclaDigitadaEhVirgula ? true : !jaExisteVirgulaNoValor)
    },

    corrigirPontosEVirgulasValorDecimal: function(valor:string) {
        return valor.replace(/\./g,"").replace(/,/,".")
    },

    parseBrazilianNumber: function(ptBrNumber) {
        // Remove pontos (.) usados como separadores de milhar e substitui vírgulas (,) por pontos.
        const normalizedNumber = ptBrNumber.replace(/\./g, '').replace(',', '.');
        
        // Converte para um número padrão JavaScript.
        const parsedNumber = parseFloat(normalizedNumber);
    
        if (isNaN(parsedNumber)) {
            this.showErrorMessage('O número fornecido não é válido no formato pt-BR.');
            return null;
        }
    
        return parsedNumber.toString();
    },
/*
    consts: {
        itensSemOrdenacao: "ItensSemOrdenacao",
        itensSelecionados: "ItensSelecionados"
    },
*/
    localStorage: {
        getData: function (key) {
            return JSON.parse(localStorage.getItem(key));
        },
        setData: function (key, value) {
            localStorage.setItem(key, JSON.stringify(value));
        }

    },

    sessionStorage: {
        getData: function (key) {
            return JSON.parse(sessionStorage.getItem(key));
        },
        setData: function (key, value) {
            sessionStorage.setItem(key, JSON.stringify(value));
        },
        removeData: function (key) {
            sessionStorage.removeItem(key);
        }

    },

    getBrowserData: function () {
        var data: any = {};

        if (navigator.userAgent.match(/Trident\/7/)) {
            data.browser = "MSIE";
            data.version = "11";
        }

        if (navigator.userAgent.match(/Trident\/6/)) {
            data.browser = "MSIE";
            data.version = "10";
        }

        if (navigator.userAgent.match(/Trident\/5/)) {
            data.browser = "MSIE";
            data.version = "9";
        }

        if (navigator.userAgent.match(/Trident\/4/)) {
            data.browser = "MSIE";
            data.version = "8";
        }

        if (navigator.userAgent.match(/Chrome/)) {
            data.browser = "Chrome";
        }

        if (navigator.userAgent.match(/Firefox/)) {
            data.browser = "Firefox";
        }

        return data;
    },

    showLoading: function (el) {
        $.blockUI.defaults.baseZ = 10000;
        if (el) {
            $(el).block({ message: '<span id="block-message">Aguarde</span>' });

        } else {
            $.blockUI({ message: '<span id="block-message">Aguarde</span>', fadeIn: 0 });
        }

        this.startBlockMessageAnimation();
    },

    hideLoading: function (el) {
        if (el) {
            $(el).unblock();
        } else {
            $.unblockUI();
        }

        this.stopBlockMessageAnimation();
    },

    startBlockMessageAnimation: function () {
        this.stopBlockMessageAnimation();
        this.dots = 0;
        this.blockMessageAnimation = setInterval(this.animateBlockMessageAnimation, 400);
    },

    animateBlockMessageAnimation: function () {
        if (!globalMU.dots)
            globalMU.dots = 0;

        $("#block-message").html("Aguarde" + Array((++globalMU.dots % 4) + 1).join("."));
        if (globalMU.dots === 3) {
            globalMU.dots = 0;
        }
    },

    stopBlockMessageAnimation: function () {
        if (this.blockMessageAnimation) {
            clearInterval(this.blockMessageAnimation);
        }
    },

    getElementFontSize: function (context) {
        return parseFloat(getComputedStyle(context || document.documentElement).fontSize);
    },

    convertRem: function (value) {
        return this.convertEm(value);
    },

    convertEm: function (value, context) {
        return value * this.getElementFontSize(context);
    },

    formatJsonDate: function (date, format?) : string {
        moment.locale("pt-br");

        if (!format) {
            format = "DD/MM/YYYY";
        }

        var formatDate = moment(date.replace("\\", ""));
        return formatDate.format(format);
    },

    toDate: function (date, format) {
        moment.locale("pt-br");
        if (date == null) return new Date(0, 0, 1);
        
        var formatDate = format ? moment(date.replace("\\", ""), format) : moment(date.replace("\\", ""));
        return moment(formatDate).toDate();

    },

    formatExtensionDate: function (date) {
        moment.locale("pt-br");
        var formatDate = moment(date.replace("\\", ""));
        return formatDate.format("DD MMM YYYY");
    },

    formatDateTime: function (date) {
        return this.formatDate(date, "DD/MM/YYYY HH:mm");
    },

    formatDate: function (date, format?) {

        if (!date) {
            return null;
        }

        moment.locale("pt-br");
        if (!format) {
            format = "DD/MM/YYYY";
        }

        if (this.isAspNetJsonDate(date)) {
            return this.formatJsonDate(date, format);
        }

        if (date instanceof Date) {
            var formatDate = moment(date);
            return formatDate.format(format);
        } else if (typeof date == "string") {

            var arr = date.split("/");
            var arrFormat = format.split("/");

            if (arr.length == arrFormat.length) {

                var d, m, y;

                for (var i = 0; i < arr.length; i++) {

                    var f = arrFormat[i];
                    var v = globalMU.replaceAll(arr[i], "_", "");

                    if (v.length < f.length) {
                        continue;
                    }

                    switch (f.toLowerCase()) {
                        case "dd":
                            d = v;
                            break;
                        case "mm":
                            m = v;
                            break;
                        case "yyyy":
                            y = v;
                            break;
                    }
                }

                if (!d || !m || !y) {
                    return date;
                }

                date = new Date(y, m - 1, d);
                var formatDate = moment(date);
                return formatDate.format(format);

            }
        }

        var formatDate = moment(date);
        return formatDate.isValid() ? formatDate.format(format) : null;
    },

    converterDataFormatoPTParaDate: function(data:DataFormatoPT) : Date {

        if (globalMU.isNull(data)) {
            return null
        }

        if (globalMU.isEmpty(data)) {
            return null
        }

        const dia = data.substring(0,2)
        const mes = data.substring(3,5)
        const ano = data.substring(6,10)


        const retorno = new Date(parseInt(ano), parseInt(mes)-1, parseInt(dia))
        return retorno
    },

    converterDataFormatoPTParaEN: function(data:DataFormatoPT) : DataFormatoEN {

        if (globalMU.isNull(data)) {
            return null
        }

        if (globalMU.isEmpty(data)) {
            return ""
        }

        const dia = data.substring(0,2)
        const mes = data.substring(3,5)
        const ano = data.substring(6,10)

        return `${ano}-${mes}-${dia}`
    },

    converterDataFormatoENParaPT: function(data:DataFormatoEN) : DataFormatoPT {

        if (globalMU.isNull(data)) {
            return null
        }

        if (globalMU.isEmpty(data)) {
            return ""
        }
        
        const ano = data.substring(0,4)
        const mes = data.substring(5, 7)
        const dia = data.substring(8,10)

        return `${dia}/${mes}/${ano}`
    },

    

    converterDataHoraFormatoENComTParaDataFormatoPT: function(dataHora:DataHoraFormatoENComT) : DataFormatoPT {
        if (globalMU.isNull(dataHora)) {
            return null
        }

        if (globalMU.isEmpty(dataHora)) {
            return ""
        }

        const ano = dataHora.substring(0,4)
        const mes = dataHora.substring(5, 7)
        const dia = dataHora.substring(8,10)

        return `${dia}/${mes}/${ano}`
    },

    converterDataHoraFormatoENComTParaDataFormatoEN: function(dataHora: DataHoraFormatoENComT) : DataFormatoEN {
        if (globalMU.isNull(dataHora)) {
            return null
        }

        if (globalMU.isEmpty(dataHora)) {
            return ""
        }

        const ano = dataHora.substring(0,4)
        const mes = dataHora.substring(5, 7)
        const dia = dataHora.substring(8,10)

        return `${ano}-${mes}-${dia}`
    },

    converterObjetoDateParaDataFormatoEN: function(data:Date) : DataFormatoEN {
        return dateFns.format(data, "yyyy-MM-dd")
    },

    converterObjetoDateParaDataFormatoPT: function(data:Date) : DataFormatoPT {
        return dateFns.format(data, "dd/MM/yyyy")
    },

    dataNoFormatoPTEhValida: function(data:DataFormatoPT) {
        const formatoValido = () => /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/.test(data)

        const dataValida = () => !isNaN(dateFns.parse(data,"dd/MM/yyyy", new Date()).getDate())

        return formatoValido() && dataValida()
    },

    dataNoFormatoENEhValida: function(data: DataFormatoEN) {
        const formatoValido = () => /[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(data)

        const dataValida = () => !isNaN(dateFns.parse(data,"yyyy-MM-dd", new Date()).getDate())

        return formatoValido() && dataValida()
    },

    dataHoraFormatoENComTEhValida: function(data: DataHoraFormatoENComT) {
        const formatoValido = () => /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}/.test(data)

        const dataValida = () => !isNaN(dateFns.parse(data,"yyyy-MM-dd'T'HH:mm:ss", new Date()).getDate())

        return formatoValido() && dataValida()
    },

    formatHourMinute: function (date) {
        moment.locale("pt-br");
        var formatDate = moment(date.replace("\\", ""));
        return formatDate.format("HH:mm");
    },

    addValidators: function () {

        this.addTimeValidator();
        this.addDateGreaterThanOrEqualValidator();
        this.addDateValidator();
        this.addDateGreaterOrEqualThanActualDateValidator();
        this.addMinValueValidator();
        this.addMaxValueValidator();
        this.addCpfCnpjValidator();
        this.addNumberMaxValueValidator();
        this.addPasswordValidator();
        this.addGreaterThanValidator();
        this.addLessThanValueValidator();
        this.addNotLessThanValueValidator();
        this.addNotGreaterThanValueValidator();
        this.addNotGreaterOrEqualsThanValueValidator();
        this.addEmailCommaListValidator();
    },

    addPasswordValidator: function () {
        $.validator.addMethod("validatePassword",
            function (value, element, params) {

                var password = value;
                var confirmation = $(params).val();

                return password == confirmation;
            });
    },

    addEmailCommaListValidator: function () {

        $.validator.addMethod("emailCommaList",
            function (value, element) {

                if (!value) {
                    return true;
                }
                var arr = value.split(",");

                for (var i = 0; i < arr.length; i++) {
                    var email = arr[i].trim();

                    if (!globalMU.validateEmail(email)) {
                        return false;
                    }
                }
                return true;
            });

    },

    addDateValidator: function () {
        $.validator.addMethod("validateDate",
            function (value, element) {

                if (!value) {
                    return true;
                }

                return globalMU.validateDate(value);
            });
    },

    addGreaterThanValidator: function () {
        $.validator.addMethod("greaterThanValue",
            function (value, element, params) {
                return value && globalMU.unformatNumber(value) > params;
            });
    },

    addLessThanValueValidator: function () {
        $.validator.addMethod("lessThanValue",
            function (value, element, params) {
                return value && globalMU.unformatNumber(value) < params;
            });
    },

    addNotLessThanValueValidator: function () {
        $.validator.addMethod("notLessThanValue",
            function (value, element, params) {
                return value && !(globalMU.unformatNumber(value) < params);
            });
    },

    addNotGreaterThanValueValidator: function () {
        $.validator.addMethod("notGreaterThanValue",
            function (value, element, params) {
                var $el = $(params);
                return value && $el && $el.length > 0 && !(globalMU.unformatNumber(value) > $el.val());
            });
    },

    addNotGreaterOrEqualsThanValueValidator: function () {
        $.validator.addMethod("notGreaterOrEqualsThanValue",
            function (value, element, params) {
                var $el = $(params);
                return value && $el && $el.length > 0 && !(globalMU.unformatNumber(value) >= $el.val());
            });
    },

    addCpfCnpjValidator: function () {
        $.validator.addMethod("validateCpfCnpj",
            function (value, element) {

                if (!value) {
                    return true;
                }

                var valid = false;

                globalMU.ajax({
                    url: "/Comum/ValidarCpfCnpj",
                    type: "post",
                    async: false,
                    cache: false,
                    beforeSend: function (xhr) {
                        const abaId = sessionStorage.getItem('aba_id');
                        if (abaId) {
                            xhr.setRequestHeader("XAbaId", abaId);
                        }
                    },
                    data: {
                        numeroCpfCnpj: value
                    },
                    success: function (data) {
                        valid = data == 1;
                    }
                });

                return valid;
            });
    },

    addDateGreaterOrEqualThanActualDateValidator: function () {
        $.validator.addMethod("dateGreaterOrEqualThanActualDate",
            function (value, element) {

                if (!value) {
                    return true;
                }

                return globalMU.dateGreaterOrEqualThanActualDate(value);
            });
    },

    validateNumberMaxValue: function (type, value) {

        if (!type || !value) {
            return true;
        }

        var valid = false;

        $.ajax({
            url: "/Comum/ValidateNumberMaxValue",
            async: false,
            cache: false,
            method: "POST",
            beforeSend: function (xhr) {
                        const abaId = sessionStorage.getItem('aba_id');
                        if (abaId) {
                            xhr.setRequestHeader("XAbaId", abaId);
                        }
                    },
            data: {
                type: type,
                value: value
            },

            success: function (data) {
                valid = data == "1";
            }
        });

        return valid;

    },

    addNumberMaxValueValidator: function () {
        $.validator.addMethod("numberMaxValue",
            function (value, element, params) {
                return globalMU.validateNumberMaxValue(params, value);
            });
    },

    validateDate: function (date) {
        if (!date) {
            return false;
        }

        var valid = false;

        $.ajax({
            url: "/Comum/ValidateDate",
            async: false,
            cache: false,
            method: "POST",
            beforeSend: function (xhr) {
                        const abaId = sessionStorage.getItem('aba_id');
                        if (abaId) {
                            xhr.setRequestHeader("XAbaId", abaId);
                        }
                    },
            data: {
                date: date
            },

            success: function (data) {
                valid = data == "1";
            }
        });

        return valid;
    },

    validateInt32: function (value) {
        if (value == undefined) {
            return false;
        }

        var valid = false;

        $.ajax({
            url: "/Comum/ValidateInt32",
            async: false,
            cache: false,
            method: "POST",
            beforeSend: function (xhr) {
                        const abaId = sessionStorage.getItem('aba_id');
                        if (abaId) {
                            xhr.setRequestHeader("XAbaId", abaId);
                        }
                    },
            data: {
                value: value
            },

            success: function (data) {
                valid = data == "1";
            }
        });

        return valid;
    },

    validateNumberInteger: function (value) {
        const regex = /^[0-9]*$/;
        return regex.test(value);
    },

    dateGreaterOrEqualThanActualDate: function (date) {
        if (!date) {
            return false;
        }

        var valid = false;

        $.ajax({
            url: "/Comum/DateGreaterOrEqualThanActualDate",
            async: false,
            cache: false,
            method: "POST",
            beforeSend: function (xhr) {
                        const abaId = sessionStorage.getItem('aba_id');
                        if (abaId) {
                            xhr.setRequestHeader("XAbaId", abaId);
                        }
                    },
            data: {
                date: date
            },

            success: function (data) {
                valid = data == "1";
            }
        });

        return valid;
    },

    isDateGreaterThanOrEqual: function (initialDate, finalDate) {
        if (!initialDate || !finalDate) {
            return false;
        }

        var valid = false;

        $.ajax({
            url: "/Comum/IsDateGreaterThanOrEqual",
            async: false,
            cache: false,
            method: "POST",
            beforeSend: function (xhr) {
                        const abaId = sessionStorage.getItem('aba_id');
                        if (abaId) {
                            xhr.setRequestHeader("XAbaId", abaId);
                        }
                    },
            data: {
                initialDate: initialDate,
                finalDate: finalDate
            },
            success: function (data) {
                valid = data == "1";
            }
        });

        return valid;
    },

    addTimeValidator: function () {

        $.validator.addMethod("validateTime",
            function (value, element) {
                return /^(([0-1]?[0-9])|([2][0-3])):([0-5]?[0-9])(:([0-5]?[0-9]))?$/i.test(value);
            });

    },

    addDateGreaterThanOrEqualValidator: function () {
        $.validator.addMethod("dateGreaterThanOrEqual",
            function (value, element, params) {

                var initialDate = $(params).val();
                var finalDate = value;

                if (!initialDate || !finalDate) {
                    return true;
                }

                return globalMU.isDateGreaterThanOrEqual(initialDate, finalDate);
            });
    },

    addMinValueValidator: function () {

        $.validator.addMethod("minValue",
            function (value, element, params) {
                return parseFloat(value) > params;
            });

    },

    addMaxValueValidator: function () {

        $.validator.addMethod("maxValue",
            function (value, element, params) {
                return parseFloat(value.replace(",", ".")) <= params;
            });

    },

    convertFormToJSON: function (options):any {

        var form = options.selector ? $(options.selector) : options.element;
        var mapper = options.mapper;

        var disabled = form.find(":input:disabled").removeAttr("disabled");

        var array = form.serializeArray();

        disabled.attr("disabled", "disabled");

        var json = {};

        $.each(array,
            function () {
                var value = this.value || "";

                var map = mapper && mapper[this.name] ? mapper[this.name] : this.name;

                if (json[map]) {
                    if (!$.isArray(json[map])) {
                        var previousValue = json[map];
                        json[map] = new Array();
                        json[map].push(previousValue);
                    }
                    json[map].push(value);

                } else {
                    json[map] = value;
                }
            });

        return json;
    },

    getRandomColor: function () {
        var letters = "0123456789ABCDEF".split("");
        var color = "#";
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    },

    clearFormFields: function (options) {
        this.clearFields(options);
    },

    escapeRegExp: function (string) {
        return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    },

    replaceAll: function (string, find, replace) {

        if (!string) {
            return null;
        }

        return string.replace(new RegExp(this.escapeRegExp(find), "g"), replace);
    },

    validateEmail: function (email) {
        var filter =
            /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (filter.test(email)) {
            return true;
        } else {
            return false;
        }
    },

    validateMultipleEmails: function (emailsString) {
        // Verifica se a string está vazia ou nula
        if (!emailsString || emailsString.trim() === '') {
            return true;
        }

        // Divide a string pelos ponto e vírgula
        const emailArray = emailsString.split(';');
        
        // Remove espaços em branco e filtra strings vazias
        const cleanedEmails = emailArray
            .map(email => email.trim())
            .filter(email => email !== '');
        
        // Valida cada email
        for (let i = 0; i < cleanedEmails.length; i++) {
            let email = cleanedEmails[i];
            email = email.replace(/;/g, ''); // Remove qualquer ponto e vírgula residual
            email = email.replace(/,/g, ''); // Remove qualquer vírgula residual
            email = email.replace(/\s+/g, ''); // Remove qualquer espaço em branco residual
            
            
            // Se o validateEmail retornar false, sai do método retornando false
            if (!globalMU.validateEmail(email)) {
                globalMU.showErrorMessage(`Email [${email}] inválido`);
            return false;
            }
        }
        
        // Se todos os emails forem válidos, retorna true
        return true;
    },

    confirm: function (messages, callback?) {

        console.log('globalMU.confirm chamado. messages: ', messages)

        var message = "";

        if (typeof messages != "string") {
            $.each(messages,
                function () {
                    message += this + "<br>";
                });
        } else {
            message = messages;
        }
        return confirm(message);
    },

    showMessage: function (messages, title, css) {

        var message = "";

        if (typeof messages != "string") {
            $.each(messages,
                function () {
                    message += this + "<br>";
                });
        } else {
            message = messages;
        }
        message = message.replace(new RegExp("¤", 'g'), "<br>");
        message = message.replace(new RegExp("&#164;", 'g'), "<br>");
        if (message.toUpperCase().substring(message.length - 8) === "<BR><BR>") {
            message = message.substring(0, message.length - 8);
        }
        if (message.toUpperCase().substring(message.length - 4) === "<BR>") {
            message = message.substring(0, message.length - 4);
        }

        toastr.options = {
            "closeButton": true,
            "debug": false,
            "positionClass": "toast-top-center",
            "onclick": null,
            "showDuration": "3000",
            "hideDuration": "10",
            "extendedTimeOut": "500",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut",
            "newestOnTop": true,
            "opacity": "1 !important",
            "progressBar": true,
        };

        if (css === "success") {
            title = title === undefined ? "Sucesso!" : title;

            toastr.success(message, title);
        } else if (css === "warn") {
            title = title === undefined ? "Aviso!" : title;

            toastr.warning(message, title);
        } else if (css === "info") {
            title = title === undefined ? "Informação!" : title;

            toastr.info(message, title);
        } else {
            title = title === undefined ? "Erro!" : title;

            toastr.error(message, title);
        }

    },

    limparErrorMensage: function () {
        toastr.remove();
    },

    showErrorMessage: function (messages?) {
        this.showMessage(messages, null, "error");
    },

    showWarnMessage: function (messages) {
        this.showMessage(messages, null, "warn");
    },

    showSuccessMessage: function (messages) {
        this.showMessage(messages, null, "success");
    },

    showInfoMessage: function (messages) {
        this.showMessage(messages, null, "info");
    },

    showDefaultErrorMessage: function () {
        this.showErrorMessage("Ocorreu um problema com a requisição, por favor tente novamente.");
    },

    sortSelect: function (select) {

        var options = $(select + " option");

        var arr = options.map(function (_, o) {
            return {
                t: $(o).text(),
                v: o.value
            };
        }).get();
        arr.sort(function (o1, o2) {
            return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0;
        });
        options.each(function (i, o) {

            o.value = arr[i].v;
            $(o).text(arr[i].t);
        });

    },

    numeric: function (options) {

        var $el = options.selector
            ? $(options.selector, options.region)
            : options.element;

        if (!$el || $el.length == 0) {
            return;
        }

        $el.numeric();

        $el.bind("mouseenter",
            function (e) {
                var val = $(this).val();
                if (val != "0") {
                    val = val.replace(/[^0-9]+/g, "");
                    $(this).val(val);
                    $(this).trigger('change');
                }
            });

        $el.bind("paste",
            function (e) {
                var self = this;
                setTimeout(function () {
                    var val = $(self).val();
                    val = val.replace(/[^0-9]+/g, "");
                    $(self).val(val);
                    $(self).trigger('change');
                },
                    200);
            });

    },

    isFormValid: function (element, showMessage?) {

        var $element = element instanceof jQuery ? element : $(element);

        if (!$element || $element.length == 0) {
            return true;
        }

        var validator = $.data($element[0], "validator");
        validator.showMessage = showMessage;
        return validator.form();
    },

    bindJSONToForm: function (formSelector, json) {

        var $form = $(formSelector);
        $.each(json, function (key, value) {
            var $ctrl = $form.find('[name=' + key + ']');
            switch ($ctrl.attr("type")) {
                case "checkbox":
                    if (value == '1' || value == true || value == 'on')
                        $ctrl.prop('checked', true);
                    else
                        $ctrl.prop('checked', false);
                    break;
                default:
                    $ctrl.val(value);
            }
        });
    },

    updateJSONData: function (jsonFrom, jsonTo) {
        $.each(jsonFrom,
            function (key, value) {
                jsonTo[key] = value;
            });
    },

    applyCalendars: function (el) {

        if (el && !(el instanceof jQuery)) {
            el = $(el);
        }

        this.applyingCalendars = true;

        $('[calendar]:not(:has(>input[data-bind*="datepicker"]))', el).datetimepicker({
            locale: "pt-br",
            keepOpen: false,
            format: "DD/MM/YYYY"
        });

        var inputs = $("input", $("[calendar]", el)).not('[data-bind*="datepicker"]');

        $.each(inputs,
            function () {

                if (!$._data(this, "events").keydown) {
                    return;
                }

                $.each($._data(this, "events").keydown,
                    function () {

                        if (!this.handler) {
                            return;
                        }

                        var handler = this.handler;

                        this.handler = $.proxy(function (h, e) {
                            var event = $.Event("dpkeypress");
                            event.which = e.which;
                            $(this).trigger(event);
                            h(e);
                            return true;
                        },
                            this,
                            handler);

                    });


            });

        this.applyingCalendars = false;

    },

    applyMasks: function (el?) {

        if (el && !(el instanceof jQuery)) {
            el = $(el);
        }

        this.applyCalendars(el);

        $("[mask-data]", el).inputmask({
            mask: "99/99/9999"
        });

        $("[mask-datahora]", el).inputmask({
            mask: "99/99/9999 99:99"
        });

        globalMU.numeric({
            selector: "[numeric]",
            region: el
        });
        $("[mask-telefone]", el).inputmask("(99) 9999[9]-9999");


        $("[change-mask-telefone]", el).on("keypress", function () {
            if (!$(this, el).inputmask("hasMaskedValue")) {
                $(this, el).inputmask("(99) 9999[9]-9999");
            }
        });
        $("[mask-hora]", el).inputmask("99:99");
        $("[mask-cpf]", el).inputmask("999.999.999-99");
        $("[mask-cep]", el).inputmask("99.999-999");
        $("[mask-cnpj]", el).inputmask("99.999.999/9999-99");
        $("[mask-numero]", el).inputmask("9999999999");
        $("[mask-pis]", el).inputmask("9.999.999.999.9");

        this.applyNumericMask({ region: el });

        $("[mask]", el).each(function () {
            var e = $(this);
            var mask = e.attr("mask");

            if (mask.indexOf('9') != -1) {
                e.inputmask(e.attr("mask"));
            } else {
                (window as any).mascaraDecimaisComponent.aplicar(e);
            }
        });
    },

    applyNumericMask: function (config) {

        var options = {
            alias: 'decimal',
            radixPoint: ',',
            groupSeparator: '.',
            digits: config.digits || 2,
            digitsOptional: false,
            positionCaretOnTab: false,
            rightAlign: true,
            autoGroup: true,
            onKeyDown: function (event) {
                //if (config.ativarNavegacaoGridItens) (window as any).controleNavegacaoGridItens.tratarEvento(event, this)
            }
        };

        var inputs;

        if (!config.element) {
            inputs = $("input[mask-decimal]:not([type=number])", config.region);
        } else {
            inputs = $(config.element);
        }

        if (!inputs || inputs.length == 0) {
            return;
        }

        $.each(inputs,
            function () {
                var $this = $(this);
                var elementOptions = $this.attr("mask-decimal");
                var opt = $.extend({}, options);
                if (elementOptions) {
                    var jsonOptions = JSON.parse(elementOptions);
                    opt = $.extend(opt, jsonOptions);
                }
                $this.inputmask(opt);
            });
    },



    intersects: function (r1start, r1end, r2start, r2end) {
        return (r1start == r2start) || (r1start > r2start ? r1start <= r2end : r2start <= r1end);
    },

    fromDateToArray: function (date) {
        moment.locale("pt-br");
        return moment(date).toArray();
    },

    applyDateTimePicker: function (options) {

        var $el = options.selector ? $(options.selector) : options.element;

        var minView = 0;
        var maxView = 4;

        if (options.format === "dd/mm/yyyy") {
            minView = 2;
        } else if (options.format === "hh:mm:ss") {
            minView = 0;
            maxView = 1;
        }


        return $el.datetimepicker({
            language: "pt-BR",
            todayBtn: true,
            todayHighlight: true,
            format: options.format,
            autoclose: true,
            minView: minView,
            maxView: maxView
        });
    },

    configForm: function (options) {


        var $form = options.element
            ? options.element instanceof jQuery
                ? options.element
                : $(options.element)
            : $(options.selector);

        options.form = $form;
        var validationOptions: any = {
            errorClass: "erro",
            onkeyup: false,
            errorPlacement: function (error, element) {
                return true;
            },
            focusInvalid: typeof options.focusInvalid != "undefined" ? options.focusInvalid : false,
            invalidHandler: function (event, validator) {

                var errors = validator.numberOfInvalids();

                var showMessage = validator.showMessage == undefined || validator.showMessage;
                validator.showMessage = undefined;

                if (validator && validator.currentElements) {
                    $.each(validator.currentElements,
                        function () {
                            var $el = $(this);
                            if ($el.hasClass("select2-hidden-accessible")) {
                                $(".select2-selection", $el.parent()).removeClass("erro");
                            }
                        });
                }

                if (validator && validator.errorList) {
                    $.each(validator.errorList,
                        function () {

                            var $el = $(this.element);
                            if ($el.hasClass("select2-hidden-accessible")) {
                                $(".select2-selection", $el.parent()).addClass("erro");
                            }
                        });
                }

                if (errors && showMessage) {
                    var messages = new Array();

                    $.each(validator.errorList,
                        function () {
                            messages.push(this.message);
                        });

                    globalMU.showErrorMessage(messages);

                    return false;
                }


            },
            rules: options.rules,
            messages: options.messages
        };

        if (options.ignore) {
            validationOptions.ignore = options.ignore;
        }

        if (options.submitHandler) {
            validationOptions.submitHandler = options.submitHandler;
        }

        $form.validate(validationOptions);

    },

    resolveNumericData: function (data) {

        for (var d in data) {

            if ($.isArray(data[d]) || typeof data[d] == "object") {
                this.resolveNumericData(data[d]);
            } else {
                if (typeof data[d] == "string" && data[d].indexOf(".") > -1 && data[d].indexOf(",") > -1 && !(data[d].match(/[a-z]/gi))) {
                    var value = this.unformatNumber(data[d]);

                    if ($.isNumeric(value)) {
                        data[d] = value;
                    }
                }
            }
        }

    },

    ajax: function (args: {
        blockUI?: boolean,
        async?: boolean,
        cache?: boolean,
        url: string,
        success?: (data?:any) => void,
        error?: (jqXHR?, message?, error?) => void,
        type: "post" | "get",
        contentType?: "application/json",
        data?: any,
        showDefaultErrorMessage?: boolean,
        mostrarMensagensParaUsuario?: boolean,
        beforeSend?: (xhr?) => void
    }): Promise<any> {
        return new Promise(async (resolve, reject) => {


            if (typeof args.blockUI == "undefined" || args.blockUI) {
                this.blockUI();
            }

            var successCallback = typeof args.success != "undefined" ? args.success : null;
            var errorCallback = typeof args.error != "undefined" ? args.error : null;

            var ajaxData = args;

            if (typeof ajaxData.data == "string") {
                var d = JSON.parse(ajaxData.data);
                this.resolveNumericData(d);
                ajaxData.data = globalMU.toJSONString(d);
            } else if (!(ajaxData.data instanceof FormData)) {
                this.resolveNumericData(ajaxData.data);
            }

            if (!ajaxData.contentType && ajaxData.type != "get" && !(ajaxData.data instanceof FormData)) {
                ajaxData.contentType = "application/json";

                if (typeof ajaxData.data == "object") {
                    ajaxData.data = globalMU.toJSONString(ajaxData.data);
                }
            }

            ajaxData.beforeSend = function(xhr) {
                const abaId = sessionStorage.getItem('aba_id');
                if (abaId) {
                    xhr.setRequestHeader("XAbaId", abaId);
                }
            };


            ajaxData.success = $.proxy(function (options, data) {

                data = globalMU.tratarRetorno(data,args.mostrarMensagensParaUsuario != undefined ? args.mostrarMensagensParaUsuario : true)

                successCallback?.(data)

                resolve(data)


                if (typeof options.blockUI == "undefined" || options.blockUI) {
                    globalMU.unblockUI()
                }

            },
                this,
                args);

            ajaxData.error = $.proxy(function (options, jqXHR, textStatus, errorThrown) {

                var blockUI = typeof options.blockUI == "undefined" || options.blockUI;

                if (jqXHR.status == "200" && successCallback) {
                    successCallback()
                    resolve(undefined)

                    if (blockUI) {
                        globalMU.unblockUI();
                    }
                    return;
                } else if (errorCallback) {
                    errorCallback(jqXHR, textStatus, errorThrown)
                    reject({jqXHR,textStatus,errorThrown})

                    if (blockUI) {
                        globalMU.unblockUI();
                    }
                } else {
                    if (blockUI) {
                        globalMU.unblockUI();
                    }
                }

                //FNX-987
                if (jqXHR.responseJSON &&
                    jqXHR.responseJSON.ExceptionType &&
                    jqXHR.responseJSON.ExceptionMessage) {

                    switch (jqXHR.responseJSON.ExceptionType) {
                        case "MicroUniverso.Core.Exceptions.DomainLayerException":
                            globalMU.showWarnMessage(jqXHR.responseJSON.ExceptionMessage);
                            break;
                        case "MicroUniverso.Core.Exceptions.SessionExpiredException":
                            globalMU.showErrorMessage(jqXHR.responseJSON.ExceptionMessage);
                            $(window).attr("permitirSairView", true);
                            setTimeout($.proxy(this.redirectToLoginPage, this), 500);
                            break;
                    }
                } else if (typeof ajaxData.showDefaultErrorMessage == "undefined" || ajaxData.showDefaultErrorMessage) {
                    globalMU.showDefaultErrorMessage();
                }
            },
                this,
                args);

            $.ajax(ajaxData);

        })
    },

    autocomplete: function (options) {

        var $el = options.selector ? $(options.selector) : options.element;

        var $select2 = $el.select2({
            placeholder: options.placeholder,
            minimumInputLength: options.minChar,
            maximumSelectionSize: options.maxSelection,
            allowClear: options.allowClear, // FNX-5270
            minimumResultsForSearch: options.minimumResultsForSearch, // FNX-5270
            multiple: options.multiple,
            width: options.width,
            initSelection: options.initSelection,
            ajax: {
                cache: true,
                allowClear: true,
                dataType: "json",
                quietMillis: 100,
                type: options.method ? options.method : "POST",
                url: options.url,
                beforeSend: function (xhr) {
                        const abaId = sessionStorage.getItem('aba_id');
                        if (abaId) {
                            xhr.setRequestHeader("XAbaId", abaId);
                        }
                    },
                data: options.ajaxData
                    ? options.ajaxData
                    : function (term, id) {
                        var data = {};
                        data["term"] = term;
                        return data;
                    },
                processResults: options.processResults
                    ? options.processResults
                    : function (data) {
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.completeName,
                                    slug: item.slug,
                                    id: item.id
                                };
                            })
                        };
                    }
            }
        });

        if (options.change) {
            $select2.on("change", options.change);
        }

        if (options.val) {
            $el.select2("val", options.val);
        }

    },

    clearFields: function (options) {
        var $el = options.selector ? $(options.selector) : options.element;

        $(":input", $el)
            .not(":button, :submit, :reset, :hidden")
            .val("")
            .removeAttr("checked")
            .removeAttr("selected");
    },

    isAspNetJsonDate: function (input) {
        return /^\/?Date\((\-?\d+)/i.exec(input) !== null;
    },

    formatNumber: function (value?, precision?) {
        if (value == null) return null;
        return accounting.formatNumber(value, precision);
    },

    formatMoney: function (value?, precision?) {
        if (value == null) return null;
        return accounting.formatMoney(value, accounting.settings.currency.symbol, precision);
    },

    unformatNumber: function (value) {
        return accounting.unformat(value);
    },

    validateUrl: function (url) {
        return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|www\.)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(url);
    },

    getDecimalLength: function (value) {
        var vet = value.toString().split(".");
        return vet.length > 1 && vet[1].length > 2 ? vet[1].length : 2;
    },

    blockUI: function (options: BlockUIOptions = {el: null, tryPassiveLoading: true, message: null}) {

        if (options.tryPassiveLoading) {
            const startPassiveLoadingOk = this.startPassiveLoading()
            
            if (startPassiveLoadingOk) {
                store.dispatch(processamentoIniciadoAction())
                return;
            }
        }


        this.unblockUI()

        var el = options ? options.el : null;

        var blockOptions = {
            css: {
                border: "1px solid darkgray",
                padding: "15px",
                '-webkit-border-radius': "10px",
                '-moz-border-radius': "10px",
                width: "15%",
                zIndex: 99999
            },
            overlayCSS: {
                opacity: 0.1,
            },
            message: options?.message != null ? $(options.message) : null,
            baseZ: 99999
        };


        if (!el) {
            $.blockUI(blockOptions);
            
        } else {
            $(el).block(blockOptions);
        }

        store.dispatch(processamentoIniciadoAction())
    },

    unblockUI: function (options: UnblockUIOptions = {el: undefined}) {

        this.finishPassiveLoading()

        var el = options?.el != null ? options.el : null;

        if (el) {
            $(el).unblock();
        } else {
            $.unblockUI();
        }

        store.dispatch(processamentoFinalizadoAction())

    },

    startPassiveLoading: function() : boolean {
        // IMPORT TARDIO DE PROPOSITO - nao transformar em `import` no topo do arquivo.
        //
        // O ProvidePlugin (webpack.common.js) mapeia `global: ['globalMU','default']`, ou
        // seja: ESTE modulo e injetado como `global` em TODO modulo que use o identificador
        // livre `global` - inclusive dentro de node_modules, que ninguem daqui controla. O
        // build de DESENVOLVIMENTO do @emotion/react tem um:
        //
        //     var t = typeof globalThis !== 'undefined' ? globalThis : isBrowser ? window : global;
        //
        // Com um import estatico daqui para @mui, o grafo vira
        // globalMU -> @mui -> @emotion/react -> (ProvidePlugin) -> globalMU. Como em ESM os
        // imports rodam antes de qualquer linha do corpo, o @emotion le o `export default`
        // deste arquivo enquanto ele ainda esta inicializando, e estoura
        // "Cannot access '__WEBPACK_DEFAULT_EXPORT__' before initialization" - a tela de
        // login fica em branco no bundle dev (producao escapa porque la o `global` do
        // emotion so existe dentro da string "-global"). Ver Aprendizado_JavaScript_Build.md
        // #JS-338.
        //
        // Carregado aqui dentro, o @mui so entra no grafo quando esta funcao e chamada -
        // muito depois de o globalMU estar pronto. Mesma razao vale para qualquer import
        // novo neste arquivo: o globalMU nao pode depender da camada React/MUI no topo.
        const { renderizarComponentReact } = require('app/components/renderizarOuRemoverComponentReact')
        const { MuLinearProgress } = require('app/components/MuLinearProgress')

        return renderizarComponentReact(MuLinearProgress, "loading-passivo", true)
    },

    finishPassiveLoading: function() : boolean {
        if (document.getElementById("loading-passivo") != null) {
            document.getElementById("loading-passivo").style.display = "none"
        }
    
        
        return true
        
    },
    
    activateMenu: function (options) {

        if (options.renderViewOptions) {
            this.renderView(options.renderViewOptions);
        }

        $(".open.active,.start.active").removeClass("open").removeClass("active");

        var parents = $(options.el).parents("[data-menu]");

        $(options.el).closest("li").addClass("open active");

        $(parents).each(function () {
            $(this).addClass("open active");
        });


    },

    renderView: function (options) {

        this.blockUI();

        var self = this;

        $.ajax({
            url: options.url,
            type: options.type,
            data: options.data,
            beforeSend: function (xhr) {
                        const abaId = sessionStorage.getItem('aba_id');
                        if (abaId) {
                            xhr.setRequestHeader("XAbaId", abaId);
                        }
                    },
            cache: options.cache ? options.cache : false,
            success: function (data) {
                $(options.renderTo).html(data);
                $(document).scrollTop(0);

                self.unblockUI();

            }
        });

    },

    showDataUserMessage: function (data) {

        if (!data) {
            return;
        }

        if (data.UserMessage) {
            this.showWarnMessage(data.UserMessage);
            return;
        }

        if ($.isArray(data) && data.length > 0 && data[0].UserMessage) {
            this.showWarnMessage(data[0].UserMessage);
            return;
        }

        if (data.Entities && $.isArray(data.Entities) && data.Entities.length > 0 && data.Entities[0].UserMessage) {
            this.showWarnMessage(data.Entities[0].UserMessage);
            return;
        }

    },

    tratarRetorno: function<T> (data: RetornoApi<T>,mostrarMensagensParaUsuario:boolean = true) : DomainDataType<T> {

        if (!data) {
            return null;
        }

        mostrarMensagensParaUsuario && this.showDataUserMessage(data);

        if (data.Error) {

            switch (data.ErrorType) {
                case "DomainLayerException":
                    if (data.ErrorMessage && mostrarMensagensParaUsuario) {
                        this.showErrorMessage(data.ErrorMessage);
                    }
                    if (data.WarnMessage && mostrarMensagensParaUsuario) {
                        this.showWarnMessage(data.WarnMessage);
                    }

                    if (!data.ErrorMessage && !data.WarnMessage && data.Error && mostrarMensagensParaUsuario) {
                        this.showWarnMessage(data.Error);
                    }

                    if (typeof(data.DomainData) === "boolean" || data.DomainData == null) {
                        data.DomainData = {
                            HasErrors: data.ErrorLevel == "Error",
                            ErrorLevel: data.ErrorLevel,
                            Error: data
                        };
                    }

                    if (data.DomainData != null) {
                        (data.DomainData as DomainDataError<T>).HasErrors = data.ErrorLevel == "Error";
                        (data.DomainData as DomainDataError<T>).ErrorLevel = data.ErrorLevel;
                        (data.DomainData as DomainDataError<T>).Error = R.omit(['DomainData'],data)
                    }

                    

                    return data.DomainData;
                    
                case "AccessDenied":
                    mostrarMensagensParaUsuario && this.showErrorMessage(data.Error);
                    break;
                case "SessionExpired":
                case "SessionExpiredException":
                    mostrarMensagensParaUsuario && this.showErrorMessage(data.Error);
                    $(window).attr("permitirSairView", true);
                    setTimeout($.proxy(this.redirectToLoginPage, this), 500);
                    break;
                case "VendedorSessionExpired":
                    $(window).attr("permitirSairView", true);
                    setTimeout($.proxy(this.redirect, this, data.RedirectUrl), 500);
                    break;
                default:
                    mostrarMensagensParaUsuario && this.showErrorMessage("O sistema está temporariamente indisponível. Aguarde alguns minutos e tente novamente. Se o problema persistir entre em contato com nossa Central de Suporte.");
            }

            return null;

        } else {
            return data;
        }
    },

    where: function (list, args) {
        return _.where(list, args);
    },

    getPrecision: function (a) {
        if (!isFinite(a)) return 0;
        var e = 1, p = 0;
        while (Math.round(a * e) / e !== a) { e *= 10; p++; }
        return p;
    },

    redirectToAction: function (actionName, controllerName) {

        var url = this.getUrl(actionName, controllerName);
        this.redirect(url);
    },

    redirect: function (url) {

        if (!url) {
            return;
        }

        window.location.href = url;
    },

    redirectToLoginPage: function () {

        var self = this;

        // 491123 — sem fallback aqui, uma falha nesta chamada (ex: "serverBaseAddress"
        // ausente/comentado no Web.config local, fazendo AuthConfig.LogoutUrl estourar
        // "Value cannot be null. Parameter name: uriString") deixava o usuário travado na
        // tela após o toast de sessão expirada, sem NENHUM redirecionamento — ver
        // Aprendizado_React.md #React-249/#React-250/#React-251. success sem url e error caem no mesmo fallback: "/Login".
        $.ajax({
            url: "/Comum/ObterUrlLogoutSistemaSeguranca",
            method: "GET",
            beforeSend: function (xhr) {
                        const abaId = sessionStorage.getItem('aba_id');
                        if (abaId) {
                            xhr.setRequestHeader("XAbaId", abaId);
                        }
                    },
            success: function (url) {
                self.redirect(url || "/Login");
            },
            error: function () {
                self.redirect("/Login");
            }
        });

    },

    getUrl: function (actionName, controllerName) {
        var url = null;
        $.ajax({
            url: "/Comum/GetUrl",
            async: false,
            method: "POST",
            beforeSend: function (xhr) {
                        const abaId = sessionStorage.getItem('aba_id');
                        if (abaId) {
                            xhr.setRequestHeader("XAbaId", abaId);
                        }
                    },
            data: {
                actionName: actionName,
                controllerName: controllerName
            },
            success: function (d) {
                url = d;
            }
        });

        return url;
    },

    getRouteUrl: function (routeName) {
        var url = null;
        $.ajax({
            url: "/Comum/GetRouteUrl",
            async: false,
            method: "POST",
            beforeSend: function (xhr) {
                        const abaId = sessionStorage.getItem('aba_id');
                        if (abaId) {
                            xhr.setRequestHeader("XAbaId", abaId);
                        }
                    },
            data: {
                routeName: routeName
            },
            success: function (d) {
                url = d;
            }
        });

        return url;
    },

    applyConditionalMask: function (args) {

        if (!args) {
            return;
        }

        var $el = $(args.triggerElement);


        if (typeof args.masks != "undefined" && args.masks && args.masks.length > 0) {

            var initialMask = null;
            var maskApplied = null;
            var isMaskApplied = $el.attr("mask-applied");

            $.each(args.masks,
                function () {

                    if (this.name == args.initialMask) {
                        initialMask = this;
                    }

                    var callback = this.initialCondition && (isMaskApplied == undefined || !!isMaskApplied)
                        ? this.initialCondition
                        : this.condition;

                    var condition = callback({ target: $el[0] });

                    if (condition) {
                        maskApplied = this;
                        $el.inputmask(this.mask, args.options);
                        $el.attr("mask-applied", this.name);
                        return false;
                    }
                });

            if (!maskApplied && initialMask) {
                $el.inputmask(initialMask.mask, args.options);
                $el.attr("mask-applied", initialMask.name);
            }
        }

        var triggerCallback = function (e) {

            if (typeof args.masks != "undefined" && args.masks && args.masks.length > 0) {
                $.each(args.masks,
                    function () {
                        if (this.name != $el.attr("mask-applied") &&
                            typeof this.condition != "undefined" &&
                            this.condition &&
                            this.condition(e)) {
                            $el.inputmask(this.mask, args.options);
                            $el.attr("mask-applied", this.name);
                            return false;
                        }
                    });
            }

        };

        if (typeof args.triggerEvent == "string") {
            $el.on(args.triggerEvent, triggerCallback);
        } else {
            $.each(args.triggerEvent,
                function () {
                    $el.on(this, triggerCallback);
                });
        }


        $el.unbind("paste");

        var el = $el[0];

        if (el.inputmask && el.inputmask.events["paste"]) {

            if (el.form) {
                $(el.form).unbind("paste");
                $(el.form).off("paste", el.inputmask.events["paste"]);
            }

            delete el.inputmask.events["paste"];
        }

        $el.bind("paste",
            $.proxy(function (args, e) {

                e.preventDefault();
                var data = (window as any).clipboardData
                    ? (window as any).clipboardData.getData("Text")
                    : e.originalEvent.clipboardData ? e.originalEvent.clipboardData.getData("Text") : null;

                if (!data) {
                    return;
                }

                var el = $(e.target);

                el.inputmask("remove");
                el.val(data);
                el.change();
                el.attr("mask-applied", false);
                globalMU.applyConditionalMask(args);

            },
                this,
                args));


    },

    logError: function (message, url, line, col, error) {


        var data = {
            error: message,
            url: url,
            line: line,
            col: col,
            stack: error && typeof error.stack != "undefined" && error.stack ? error.stack : error
        };

        $.ajax({
            url: "/Comum/LogJavaScriptError",
            type: "POST",
            contentType: "application/json",
            beforeSend: function (xhr) {
                const abaId = sessionStorage.getItem('aba_id');
                xhr.setRequestHeader('XAbaId', abaId);
            },
            data: globalMU.toJSONString({
                errorData: data
            })
        }
        );

    },

    resolveDates: function (data) {

        if (!data) {
            return;
        }

        for (var key in data) {
            var value = data[key];

            if (Array.isArray(value)) {
                for (var item in value) {
                    globalMU.resolveDates(value[item]);
                }

            }

            if (typeof value == "string" && value.indexOf("Date(") > -1) {
                data[key] = moment(value).toDate();
            }
        }
    },

    isInArray: function (item, array, property) {

        if (!item || !array || array.length == 0) {
            return false;
        }

        var exists = false;

        $.each(array,
            function () {

                var value = this;

                if (property) {
                    value = this[property];
                }

                if (item == value) {
                    exists = true;
                    return false;
                }
            });

        return exists;
    },

    rgb2hex: function (rgb) {
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 4)
            ? "#" +
            ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2)
            : "";
    },

    sum: function (list, property) {

        if (!list || list.length == 0) {
            return 0;
        }

        var value = 0;

        $.each(list,
            function () {

                var item = this;

                if (item.toJSON) {
                    item = item.toJSON();
                }

                value += item[property];
            });

        return value;
    },

    cloneArray: function (array) {

        if (!array || array.length == 0) {
            return null;
        }

        var newArray = new Array();

        $.each(array,
            function () {
                var newObject = jQuery.extend(true, {}, this);
                newArray.push(newObject);
            });

        return newArray;
    },

    setCaretPosition: function (element, caretPos) {

        if (!element) {
            return;
        }

        if (element.createTextRange) {
            var range = element.createTextRange();
            range.move("character", caretPos);
            range.select();
        } else {
            if (element.selectionStart) {
                element.focus();
                element.setSelectionRange(caretPos, caretPos);
            } else
                element.focus();
        }
    },

    sleep: function (milliseconds) {
        var start = new Date().getTime();
        for (var i = 0; i < 1e7; i++) {
            if ((new Date().getTime() - start) > milliseconds) {
                break;
            }
        }
    },

    toJSONString: function (jsObject) {
        return JSON.stringify(jsObject,
            function (key, value) {
                if (value && value.nodeType) {
                    return null;
                }
                return key != "Error" ? value : null;
            });
    },

    redimensionarModal: function (container, modal) {

        $(container).css("height", $(window).height() - 100 + "px");
        $(container).css("width", $(window).width() - 30 + "px");

        $(modal + " .modal-dialog").css("position", "fixed");
        $(modal + " .modal-dialog").css("left", 10);
        $(modal + " .modal-dialog").css("width", $(window).width() - 20);

        $(container + " div:first-child:first").css("width", 1920);

    },

    token: function () {
        return window.GridController.server.token;
    },

    restUrl: function () {
        return window.GridController.server.restUrl;
    },

    enterpriseUrl: function () {
        return window.GridController.server.enterpriseUrl;
    },

    userIdForGrid: function() {
        return window.GridController.server.userId
    },

    isFloat: function (value) {
        return Number(value) === value && value % 1 !== 0;
    },

    isInt: function (value) {
        return Number(value) === value && value % 1 === 0;
    },

    corrigirCodigoProduto: function(codigo:string) {
        return codigo !== "" && codigo.length > 1 && codigo.length < 5 ? ("00000" + codigo).slice(-5) : codigo
    },

    isNullOrEmpty: function(value) {
        return R.isNil(value) || R.isEmpty(value)
    },

    isNullOrEmptyOrZero: function(value: number) {
        return globalMU.isNullOrEmpty(value) || (isNaN(Number(value)) ? true : Number(value) == 0)
    },

    isNull: function(value) {
        return R.isNil(value)
    },

    isEmpty: function(value) {
        return R.isEmpty(value)
    },

    isNotNullOrEmpty: function(value) {
        return !this.isNullOrEmpty(value)
    },

    isNullOrZero: function(value) {
        return globalMU.isNullOrEmpty(value) || value === 0
    },

    isNotNullOrZero: function(value) {
        return !globalMU.isNullOrZero(value)
    },

    valorComMascaraEhValido: function(mascara:string, valor:string) {
        const tamanhoIgual = () => mascara.length == valor.length

        const ehNumero = (chr:string) => new RegExp(/[0-9]/).test(chr)

        const ehLetra = (chr:string) => new RegExp(/[A-Za-z]/).test(chr)

        const parValido = (par:string[]) => {
            return  par[1] == "9" ? ehNumero(par[0]) :
                    par[1] == "a" ? ehLetra(par[0]) :
                    par[1] == "*" ? ehNumero(par[0]) || ehLetra(par[0]) : 
                    true
        }

        const pares = R.zip(valor.split(""),mascara.split(""))

        return tamanhoIgual() && R.all(parValido, pares)
    },

    removerMascara: function(mascara:string, valor:string, removerUnderline?:boolean) {
        const ehNumero = (chr:string) => new RegExp(/[0-9]/).test(chr)

        const ehLetra = (chr:string) => new RegExp(/[A-Za-z]/).test(chr)

        const ehLetraOuNumero = (chr:string) => ehLetra(chr) || ehNumero(chr)

        const naoEhLetraNemNumero = (chr:string) => !ehLetraOuNumero(chr)

        const removerMascara = () => {
            const caracteresDeFormatacao = R.pipe(
                () => mascara?.split("").filter(chr => naoEhLetraNemNumero(chr) && chr != "*" && (removerUnderline === true ? true : chr != "_")).concat(removerUnderline === true ? "_" : ""),
                R.uniq)
            ()
            
            return valor?.split("").reduce((acc,cur) => acc + (caracteresDeFormatacao.includes(cur) ? "" : cur),"")
        }
        
        return /*!this.valorComMascaraEhValido(mascara,valor) ? null : */removerMascara()
    },
    mascaraSemCaracteresFormatacao: function(mascara:string) {
        const ehNumero = (chr:string) => new RegExp(/[0-9]/).test(chr)

        const ehLetra = (chr:string) => new RegExp(/[A-Za-z]/).test(chr)

        const ehLetraOuNumero = (chr:string) => ehLetra(chr) || ehNumero(chr)

        const naoEhLetraNemNumero = (chr:string) => !ehLetraOuNumero(chr)

        const caracteresDeFormatacao = R.pipe(
            () => mascara.split("").filter(chr => naoEhLetraNemNumero(chr) && chr != "*"),
            R.uniq)
        ()

        return mascara.split("").reduce((acc,cur) => acc + (caracteresDeFormatacao.includes(cur) ? "" : cur),"")
    },
    togglePropriedadeBooleanaBackbone: function(model, nomePropriedade) {
        model.set(nomePropriedade,true)
        setTimeout(() => model.set(nomePropriedade,false), 100)
    },
    existeOrcamentoEmAndamento: function() { 
        return (R.pipe(
            () => store.getState?.()?.orcamento ?? {},
            Object.keys
        )()).length > 0
        
    },

    possuiPermissao: function(permissoes: Permissao[], funcionalidade: string, acao?:string) {
        
        const permissao = permissoes.find(permissao => {
            return  globalMU.isNullOrEmpty(funcionalidade) ? false :
                    globalMU.isNullOrEmpty(acao) ? permissao.Funcionalidade == funcionalidade :
                    permissao.Funcionalidade == funcionalidade && permissao.Acao == acao
        })

        return permissao?.Permitido ?? false
    },

    substituirItemEmArray: function<T>(
        array: T[],
        predicado: (item: T) => boolean,
        novoItem: any
    ) {
        const arrayCopia = [...array]

        const indiceItemAntigo = arrayCopia.findIndex(predicado)
    
        if (indiceItemAntigo == -1) {
            arrayCopia.push(novoItem)
        } else {
            arrayCopia.splice(
                indiceItemAntigo,
                1,
                novoItem
            )
        }
    
        return arrayCopia
    },

    removerSharpDeIdDeElemento: function(idElemento) {
        return idElemento.startsWith("#") ? idElemento.substring(1,idElemento.length) : idElemento
    },
    converterNomesPropriedadesParaPrimeiraLetraLowerCase: function(object) {
        if(object === undefined || object === null || typeof object !== "object") {
            return object;
        } else {
            if(Array.isArray(object)) {
                return object.map(item => globalMU.converterNomesPropriedadesParaPrimeiraLetraLowerCase(item));
            } else {
                return Object.entries(object).reduce((result, [key, value]) => {
                    result[key.charAt(0).toLowerCase() + key.slice(1)] = globalMU.converterNomesPropriedadesParaPrimeiraLetraLowerCase(value);
                    return result;
                }, {});
            }
        }
    },
    resolverNumeroCasasDecimaisDeParametroFormatado: function(valorParametro:string, numeroCasasDecimaisDefault = 3) {
        return globalMU.isNullOrEmpty(valorParametro) ? numeroCasasDecimaisDefault : R.pipe(
            () => valorParametro.indexOf(",") != -1 ? valorParametro.length - (valorParametro.indexOf(",") + 1) : 0,
            numeroCasasDecimais => numeroCasasDecimais > 3 ? 3 : numeroCasasDecimais
        )()
    },

    emptyToNull: function(valor) {
        return globalMU.isNullOrEmpty(valor) ? null : valor
    },

    removerLetrasESimbolos: function(texto:string):string {   
        return texto.replace(/\D/g, "");
    },
}

_.extend(Backbone.Model.prototype,
    {
        // Version of toJSON that traverses nested models
        toJSON: function () {
            var obj = _.clone(this.attributes);
            _.each(_.keys(obj),
                function (key) {
                    if (!_.isUndefined(obj[key]) && !_.isNull(obj[key]) && _.isFunction(obj[key].toJSON)) {
                        obj[key] = obj[key].toJSON();
                    }
                });
            return obj;
        }
    });

_.extend(Backbone.Collection.prototype,
    {
        // Version of toJSON that traverses nested models
        toJSON: function () {
            return this.map(function (model) { return model.toJSON(); });
        }
    });

window.onerror = globalMU.logError;
(window as any).global = globalMU


export default globalMU

// $(document).ready(function () {
//     globalMU.applyMasks()
//     globalMU.addValidators()
// });
